import { render, staticRenderFns } from "./IconSvgNewspaper.vue?vue&type=template&id=1ca6310a&scoped=true&"
import script from "./IconSvgNewspaper.vue?vue&type=script&lang=js&"
export * from "./IconSvgNewspaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca6310a",
  null
  
)

export default component.exports